import React, { useCallback, useEffect, useRef } from 'react';

interface SearchDropdownProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const SearchDropdown: React.FC<SearchDropdownProps> = ({ isOpen, onClose, children }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose();
      }
    },
    [onClose],
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside, isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 z-30"></div>
      <div className="absolute z-40 w-full rounded-btn border border-[#939BA4] bg-base-100">
        <div ref={dropdownRef} className="relative mt-2">
          {children}
        </div>
      </div>
    </>
  );
};

export default SearchDropdown;
